module.exports = __webpack_public_path__ + "img/03.61d800c2.png";